import React, { useCallback, useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import propTypes from 'prop-types'
import { Tooltip } from 'flowbite-react';
import { routes } from '../../../routes'
import ProfileMenu from '../ProfileMenu';
import { useSelector } from 'react-redux';
import { GET_TEAM_DETAILS } from '../../../grapghQl/queries/teams';
import { Skeleton } from '../Skeleton';
import { SettingsIcon } from '../../../theme/icons';
import { Button } from '..';
import { globalRoles } from '../../../utils/globalRoles';
import { HelpMenu } from '../HelpMenu';
import { HeaderSearch } from '../HeaderSearch';

export const Header = React.memo(({ navigate, intl }) => {
  const location = useLocation();

  const { formatMessage } = intl;
  const { user } = useSelector(state => state.auth);
  const { role, _id, customerData: {
    region = ''
  } = {} } = user;

  const { data: { teamDetailsById = {} } = {}, loading: loadDetails } = useQuery(GET_TEAM_DETAILS, {
    variables: { id: _id },
    fetchPolicy: 'no-cache'
  })
  const { first_name, last_name, } = teamDetailsById || { first_name: '', last_name: '' }

  const currentPage = React.useCallback(() => !!routes?.length && routes?.find(loc => `/${loc.path}` === location.pathname), [location])
  const { title, permissions, subTitle, region: allowedRegions = [] } = currentPage() || { title: '', permissions: [], subTitle: '', region: [] };

  const checkPermissions = useCallback(() => {
    const hasRolePermission = (permissions?.length && role && permissions.includes(role)) || (permissions?.length && permissions.includes('*'));
    const hasRegionPermission = !allowedRegions?.length || !region || allowedRegions.includes(region);

    if (!hasRolePermission || !hasRegionPermission) {
      navigate('/no-access')
    }
    // eslint-disable-next-line
  }, [role, permissions, region, allowedRegions])

  const onlyForAdmins = Boolean(role === globalRoles.admin || role === globalRoles.superAdmin);


  useEffect(() => {
    checkPermissions();
    // eslint-disable-next-line
  }, [location.pathname])

  return (
    <div className="p-5 flex-col md:flex-row flex justify-between items-end bg-white ">
      <div className="flex items-center gap-3.5 w-full">
        <div className="flex  items-center justify-between w-full">
          <div className="items-center w-full">
            <div className="flex-shrink-0 font-semibold  text-xl text-secondary-600 w-full">
              {loadDetails ? <Skeleton length={1} className={"h-10 w-2/5 rounded-10"} /> : title === "Hello" ? formatMessage({ id: "DASHBOARD.HEADER.TITLE" }, { first_name, last_name }) : title}
            </div>
            <span className='text-sm text-secondary-400'>{subTitle}</span>
          </div>
        </div>
      </div>
      <div className='flex w-full flex-col md:flex-row gap-3  items-center m-0 p-0  '>
        <HeaderSearch />
        <div className='flex gap-3 items-center p-0 m-auto justify-between'>
          <HelpMenu />
          {onlyForAdmins && <SettingsMenu navigate={navigate} />}
          <span>
            <ProfileMenu intl={intl} navigate={navigate} userName={`${first_name} ${last_name}`} />
          </span>
        </div>
      </div>
    </div>
  )
})

Header.propTypes = {
  navigate: propTypes.func
}

Header.defaultProps = {
  navigate: () => { }
}

const SettingsMenu = ({ navigate = () => null }) => {
  return (
    <span><Button text="" onClick={() => navigate('/settings')} className="flex rounded-full border border-secondary-400 !h-10 w-10 p-0 m-0"
      variant="tertiary" name="settings"
      icon={<Tooltip placement="bottom" content="Settings">
        <SettingsIcon className="w-10 h-10 p-1 m-auto flex items-center" />
      </Tooltip>
      } /> </span>
  )
}
